import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { CutOffActions, CutOffActionTypes } from '../actions/cut-off-actions';
import { RmsNextWorkingDayResponse } from '@cemex-core/cmx-api/models/next-working-day/next-working-day-res';

export interface CutOffState {
  loading: boolean;
  cutOff: RmsNextWorkingDayResponse;
}

export const initialState: CutOffState = {
  loading: false,
  cutOff: null,
};

export function cutOffReducer(state = initialState, action: CutOffActions | OrderBuilderActions): CutOffState {
  switch (action.type) {
    case CutOffActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as CutOffState;
    }
    case CutOffActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        cutOff: action.payload,
      } as CutOffState;
    }
    case RESET_BUILDER:
    case CutOffActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
